// @flow
import React from 'react'
import IconFavourite from '../../shared/icons/IconFavourite'
import IconLock from '../../shared/icons/IconLock'

type Props = {
  'private': boolean,
  favourite: boolean
}

export default class DashboardHeaderIcons extends React.Component<Props> {
  render () {
    const iconProps = {
      width: '14px',
      height: '14px'
    }

    return (
      <div style={{display: 'flex', margin: '5px'}}>
        {
          this.props.private
            ? <IconLock {...iconProps} />
            : null
        }
        <IconFavourite {...iconProps} favourite={this.props.favourite} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/components/project_dashboard/Header/DashboardHeaderIcons.js